/** Shared unit conversions for FIT's on-the-wire encodings. */

/** `positionLat`/`positionLong` are stored as FIT semicircles; converts to degrees. */
export function semicirclesToDegrees(semicircles: number): number {
  return semicircles * (180 / 2 ** 31)
}

/** Degrees back to FIT semicircles, for constructing/editing coordinates. */
export function degreesToSemicircles(degrees: number): number {
  return Math.round(degrees * (2 ** 31 / 180))
}
